import React from 'react';
import { motion } from 'framer-motion';
export function Button({
  children,
  onClick,
  href,
  className = ''
}: {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    onClick?.();
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-kitchen-green hover:bg-kitchen-green-hover text-white font-nunito font-bold py-4 px-8 rounded-xl shadow-lg text-lg md:text-xl w-full max-w-md mx-auto block transition-colors ${className}`} data-id="element-12">
      {children}
    </motion.button>;
}